import React, { FunctionComponent } from 'react';
import PtPlanDialog from './ptPlanDialog';
import { DriftThemeProvider, Dialog, DialogContent, CloseIcon, IconButton } from 'drift-ui';
import { useSelector } from 'react-redux';
import { getIsSideNavigationCollapsed } from '../../../redux/actions/appActions';

interface PtSubscriptionModalModalProps {
  open: boolean;
  sideNavWidth?: number;
  onClose: () => void;
}

export const PtSubscriptionModal: FunctionComponent<PtSubscriptionModalModalProps> = ({
  open,
  onClose,
  sideNavWidth,
}) => {
  const isCollapsed = useSelector(getIsSideNavigationCollapsed);

  return (
    <DriftThemeProvider>
      <Dialog
        open={open}
        maxWidth={false}
        sx={{
          '& .MuiDialog-container': {
            marginLeft: isCollapsed ? '70px' : '170px',
          },
          '& .MuiDialog-paper': {
            width: `min(1180px, calc(100vw - ${(sideNavWidth ?? 0) + 16}px))`,
            height: 'calc(100vh - 44px)',
          },
        }}
        onClose={onClose}
      >
        <DialogContent>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 24,
              top: 18,
              color: (theme) => theme.palette.gray[700],
            }}
          >
            <CloseIcon />
          </IconButton>
          <PtPlanDialog />
        </DialogContent>
      </Dialog>
    </DriftThemeProvider>
  );
};
